import type React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { BlockWrapper } from '../common';

/**
 * Render a tabs item (mapped in the renderer).
 */
export function BlockTabsItem(props: BlockProps): React.ReactElement {
    const { attributes, children } = props;

    return (
        <BlockWrapper {...props}>
            <div {...attributes}>{children}</div>
        </BlockWrapper>
    );
}
